module.exports = __webpack_public_path__ + "static/img/login-left-follow.cd0ce243.png";